module.exports = __webpack_public_path__ + "img/about_banner_2.fd3b3542.png";